import React, { Component, Fragment } from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { mapDispatchToProps } from '../../helpers/redux.helper'
import VoiceItem from '../VoiceItem'
import ButtonClose from '../ButtonClose'
import Drawer from 'antd/lib/drawer'
import { isSmallDisplayView } from '../../helpers/device.helper'
import './index.sass'

class Favourite extends Component {
  state = {
    isVisible: false,
  }

  onChangeVisibility = () => {
    this.cleanAudioPlayer()
    this.setState({
      isVisible: !this.state.isVisible,
    })
  }

  cleanAudioPlayer = () => {
    const {
      actions: { toggleVisibleAudioPlayer, setPlayingStatus },
    } = this.props
    setPlayingStatus(false)
    toggleVisibleAudioPlayer(false)
  }

  setAudioPlayer = () => {
    const {
      wishlist,
      actions: { setPlayList },
    } = this.props
    setPlayList(wishlist)
  }

  render = () => {
    const {
      t,
      currentVoiceId,
      isAudioPlaying,
      actions: {
        toggleFavoriteVoice,
        changeModalVisibility,
        toggleVisibleAudioPlayer,
        setPlayingStatus,
        setPlayingVoiceId,
        setChoosenVoice,
      },
			voiceDescriptions,
			wishlist,
    } = this.props
    const { isVisible } = this.state
    wishlist.length > 0 && isVisible && this.setAudioPlayer()
    return (
      <Fragment>
        <div
          className={wishlist.length > 0 ? 'favorites favorites-full' : 'favorites'}
          onClick={this.onChangeVisibility}
        ></div>
        <Drawer
          placement="right"
          closable={false}
          onClose={this.onChangeVisibility}
          visible={isVisible}
          width={!isSmallDisplayView() ? '30%' : '100%'}
          className="drawer-container"
        >
          <header className="drawer-header">
            <h5>{t('general.favourite voice')}</h5>
            <ButtonClose onHandleClick={this.onChangeVisibility} />
          </header>
          {wishlist.length > 0 ? (
            wishlist.map(elem => (
              <VoiceItem
                key={elem.id}
                voiceItem={elem}
                toggleFavoriteVoice={toggleFavoriteVoice}
                toggleVisibleAudioPlayer={toggleVisibleAudioPlayer}
                setPlayingStatus={setPlayingStatus}
                currentPlayingVoice={{ currentVoiceId, isAudioPlaying }}
                setPlayingVoiceId={setPlayingVoiceId}
                changeModalVisibility={changeModalVisibility}
                setChoosenVoice={setChoosenVoice}
                hasVoiceSescr={voiceDescriptions[elem.language.toLowerCase()] ? true : false}
              />
            ))
          ) : (
            <div className="empty-message">
              <h6>{t('general.no favourites')}</h6>
            </div>
          )}
        </Drawer>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  voiceDescriptions: state.voiceDescriptions,
  currentVoiceId: state.audioPlayer.currentVoiceId,
  isAudioPlaying: state.audioPlayer.isPlaying,
  wishlist: state.wishlist,
})

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Favourite)
)
